/* A2Z Rooms worth copying + A2Z cart drawer (4 Nov 2026). Prefix a2z-ui-rooms / a2z-ui-rd. No dependencies. */
(function () {
  if (window.__a2zRooms) return; window.__a2zRooms = true;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var lastFocus = null;

  function $(s, el) { return (el || document).querySelector(s); }
  function $$(s, el) { return Array.prototype.slice.call((el || document).querySelectorAll(s)); }

  /* ---------- rooms section: pills, markers ---------- */
  $$('[data-a2z-rooms]').forEach(function (sec) {
    var panels = $$('.a2z-ui-rooms__room', sec), pills = $('[data-a2z-pills]', sec);
    panels.forEach(function (p, i) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'a2z-ui-rooms__pill'; b.setAttribute('role', 'tab');
      b.setAttribute('aria-controls', p.id); b.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
      b.textContent = p.getAttribute('data-pill');
      b.addEventListener('click', function () {
        panels.forEach(function (q) { q.hidden = q !== p; });
        $$('.a2z-ui-rooms__pill', pills).forEach(function (x) { x.setAttribute('aria-selected', x === b ? 'true' : 'false'); });
      });
      pills.appendChild(b);
    });
    if (panels.length < 2) pills.hidden = true;
    panels.forEach(function (p) {
      $$('.a2z-ui-rooms__dot', p).forEach(function (d) {
        d.addEventListener('click', function () {
          var n = d.getAttribute('data-n');
          $$('.a2z-ui-rooms__dot', p).forEach(function (x) { x.classList.toggle('is-on', x === d); });
          $$('.a2z-ui-rooms__line', p).forEach(function (l) { l.classList.toggle('is-hl', l.getAttribute('data-n') === n); });
          var line = $('.a2z-ui-rooms__line[data-n="' + n + '"]', p);
          if (line && window.innerWidth < 900) line.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      });
    });
  });

  /* ---------- cart helpers ---------- */
  function post(url, body) {
    return fetch(root + url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  function themeRefresh(qty) {
    // keep the theme's own header count in step (cart_type is "page", so this never opens the theme drawer)
    try { document.documentElement.dispatchEvent(new CustomEvent('product:added', { bubbles: true, detail: { quantity: qty || 0 } })); } catch (e) {}
  }
  function busy(btn, on, label) {
    if (!btn) return;
    if (on) { btn.dataset.label = btn.textContent; btn.textContent = 'Adding…'; btn.disabled = true; }
    else { btn.disabled = false; btn.textContent = label || btn.dataset.label; }
  }

  /* ---------- drawer ---------- */
  var drawer = $('[data-a2z-rd]'), scrim = $('[data-a2z-rd-scrim]'), body = drawer && $('[data-a2z-rd-body]', drawer);
  function render() {
    if (!drawer) return Promise.resolve();
    return fetch(root + '?sections=a2z-cart-drawer', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var tmp = document.createElement('div'); tmp.innerHTML = j['a2z-cart-drawer'] || '';
        var wrap = $('.a2z-ui-rd__wrap', tmp) || tmp;
        body.innerHTML = ''; body.appendChild(wrap);
        var n = parseInt(wrap.getAttribute('data-count') || '0', 10);
        $('[data-a2z-rd-title]', drawer).textContent = n ? 'Your cart (' + n + ')' : 'Your cart';
      });
  }
  function open() {
    if (!drawer) { window.location.href = root + 'cart'; return; }
    lastFocus = document.activeElement;
    return render().then(function () {
      drawer.hidden = false; scrim.hidden = false;
      requestAnimationFrame(function () { drawer.classList.add('is-open'); scrim.classList.add('is-open'); });
      document.documentElement.classList.add('a2z-ui-rd-lock');
      var x = $('[data-a2z-rd-close]', drawer); if (x) x.focus();
    });
  }
  function close() {
    if (!drawer) return;
    drawer.classList.remove('is-open'); scrim.classList.remove('is-open');
    document.documentElement.classList.remove('a2z-ui-rd-lock');
    setTimeout(function () { drawer.hidden = true; scrim.hidden = true; }, 250);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* ---------- clicks (delegated: works for re-rendered drawer content and the cart page) ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-a2z-add],[data-a2z-add-room],[data-a2z-qty],[data-a2z-rd-close],[data-a2z-rd-scrim],[data-a2z-rev-step]');
    if (!t) return;
    if (t.hasAttribute('data-a2z-rd-close') || t.hasAttribute('data-a2z-rd-scrim')) { close(); return; }

    if (t.hasAttribute('data-a2z-rev-step')) {
      var box = t.closest('[data-a2z-rev]'), figs = $$('figure', box), cur = figs.findIndex(function (f) { return !f.hidden; });
      var nx = (cur + parseInt(t.getAttribute('data-a2z-rev-step'), 10) + figs.length) % figs.length;
      figs.forEach(function (f, i) { f.hidden = i !== nx; });
      $('[data-a2z-rev-pos]', box).textContent = (nx + 1) + ' / ' + figs.length;
      return;
    }

    if (t.hasAttribute('data-a2z-qty')) {
      t.disabled = true;
      post('cart/change.js', { line: parseInt(t.getAttribute('data-a2z-qty'), 10), quantity: parseInt(t.getAttribute('data-q'), 10) })
        .then(function () { themeRefresh(0); return render(); })
        .catch(function () { t.disabled = false; });
      return;
    }

    var items;
    if (t.hasAttribute('data-a2z-add-room')) {
      items = t.getAttribute('data-a2z-add-room').split(',').filter(Boolean).map(function (id) { return { id: parseInt(id, 10), quantity: 1 }; });
    } else {
      items = [{ id: parseInt(t.getAttribute('data-a2z-add'), 10), quantity: 1 }];
    }
    busy(t, true);
    post('cart/add.js', { items: items })
      .then(function () {
        themeRefresh(items.length);
        var onCartPage = document.body && /\/cart\/?$/.test(window.location.pathname);
        if (onCartPage) { window.location.reload(); return; }
        if (t.hasAttribute('data-a2z-stay')) { return render().then(function () { busy(t, false, 'Added ✓'); }); }
        busy(t, false, t.hasAttribute('data-a2z-add-room') ? 'Added ✓ View cart' : 'Added ✓');
        return open();
      })
      .catch(function (err) {
        busy(t, false, 'Not available');
        if (window.console) console.warn('a2z-rooms add failed', err && (err.description || err.message));
      });
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer && !drawer.hidden) close(); });
})();
